// make it work with --isolatedModules
export default {};
export * from "./decorators";
